// The Summary reports' Filter panel (Figma 4196:133937); matching lives in utils/summaryReports.js.
import { FilterTypes } from '@carboledger/ui';
import { formatNumber } from '@/lib/format/number';
import { EMPTY_LIST } from '@/lib/utils';
import { GHG_SAVINGS_RANGES, SUMMARY_FILTER_FIELDS } from '../utils/summaryReports';

const distinctOptions = (rows, key, toLabel = String) =>
  [...new Set(rows.map((row) => row[key]).filter((value) => value != null && value !== ''))]
    .sort((a, b) => (typeof a === 'number' ? a - b : String(a).localeCompare(String(b))))
    .map((value) => ({ value: String(value), label: toLabel(value) }));

/** The Filter panel's groups; GHG emissions, country and raw material list what the report holds. */
export const buildSummaryFilters = (t, rows = EMPTY_LIST) => [
  {
    field: SUMMARY_FILTER_FIELDS.ghgSavings,
    label: t('FIELD_GHG_EMISSION_SAVINGS'),
    type: FilterTypes.checkbox,
    options: GHG_SAVINGS_RANGES.map((range) => ({
      value: range.value,
      label:
        range.min == null
          ? t('INVENTORY_FILTER_GHG_SAVINGS_BELOW', { value: range.max })
          : t('INVENTORY_FILTER_GHG_SAVINGS_RANGE', { from: range.min, to: range.max }),
    })),
  },
  {
    field: SUMMARY_FILTER_FIELDS.ghgEmissions,
    label: t('FIELD_GHG_EMISSIONS'),
    type: FilterTypes.checkbox,
    options: distinctOptions(rows, 'ghgEmissionsRaw', formatNumber),
  },
  {
    field: SUMMARY_FILTER_FIELDS.countryOfOrigin,
    label: t('FIELD_COUNTRY_OF_ORIGIN'),
    type: FilterTypes.checkbox,
    options: distinctOptions(rows, 'countryOfOriginRaw'),
  },
  {
    field: SUMMARY_FILTER_FIELDS.rawMaterialType,
    label: t('FIELD_RAW_MATERIAL_TYPE'),
    type: FilterTypes.checkbox,
    options: distinctOptions(rows, 'rawMaterialTypeRaw'),
  },
];
